import { render, staticRenderFns } from "./splash-screen.vue?vue&type=template&id=0e39415e&"
import script from "./splash-screen.vue?vue&type=script&lang=js&"
export * from "./splash-screen.vue?vue&type=script&lang=js&"
import style0 from "./_splash-screen.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports